import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { Form, FormInput } from '../core/Formikfy';
import { Alert } from '@material-ui/lab';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Avatar from '@material-ui/core/Avatar';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/Card/Card';
import { CardHeader } from '../components/Card/CardHeader';
import { CardBody } from '../components/Card/CardBody';
import { CardFooter } from '../components/Card/CardFooter';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Fade from '@material-ui/core/Fade';
import { useStyles } from './styles';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';

export const Signin = () => {
  const classes = useStyles();
  const { login } = useAuth();
  const [message, setErrorMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);
  const navigate = useNavigate();
  return (
    <Grid container component="main" className={classes.container}>
      <Grid item xs={10} sm={8} md={6} lg={3}>
        <Fade in={checked}>
          <Card>
            <CardHeader>
              <Avatar className={classes.avatar}>
                <LockOpenOutlinedIcon fontSize="small" />
              </Avatar>
              <Typography
                variant="h6"
                style={{
                  color: 'white',
                  fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
                  marginTop: '20px',
                }}
              >
                Sign In
              </Typography>
            </CardHeader>
            <CardBody>
              <Form
                id="input-with-icon-grid"
                className={classes.form}
                initialValues={{
                  email: '',
                  password: '',
                }}
                onSubmit={async (data) => {
                  try {
                    setLoading(true);
                    await login(data.email, data.password);
                    navigate('/app');
                  } catch (error) {
                    setErrorMessage(error.message);
                    setShowAlert(true);
                    setLoading(false);
                  }
                }}
              >
                <Grid container spacing={1} alignItems="flex-end" className={classes.formContent}>
                  <Grid item xs={1}>
                    <AccountCircleOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={10} className={classes.formInput}>
                    <FormInput
                      type="email"
                      label="Email"
                      name="email"
                      variant="standard"
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end" className={classes.formContent}>
                  <Grid item xs={1}>
                    <LockOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={10} className={classes.formInput}>
                    <FormInput
                      type="password"
                      label="Password"
                      name="password"
                      variant="standard"
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                {showAlert && <Alert severity="error">{message}</Alert>}
                <Button
                  disabled={loading}
                  type="submit"
                  fullWidth={true}
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Sign In
                </Button>
              </Form>
            </CardBody>
            <CardFooter>
              <Grid container>
                <Grid item xs>
                  <Link href="/reset-password" onClick={() => setChecked(false)}>
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="/signup" onClick={() => setChecked(false)}>
                    {'Sign Up'}
                  </Link>
                </Grid>
              </Grid>
            </CardFooter>
          </Card>
        </Fade>
      </Grid>
    </Grid>
  );
};
